import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const PRESTATIONS = [
  { title: "Isolation intérieure", text: "Isolation thermique et acoustique des murs, plafonds et volumes intérieurs.", to: "/isolation-interieure-seine-et-marne" },
  { title: "Plaquisterie", text: "Création de murs, habillages et ouvrages en plaques de plâtre.", to: "/plaquiste-seine-et-marne" },
  { title: "Cloisons", text: "Cloisons placo sur ossature métallique pour organiser les volumes et séparer les espaces.", to: "/plaquiste-seine-et-marne" },
  { title: "Doublages", text: "Doublage des murs existants : confort acoustique et performance thermique.", to: "/plaquiste-seine-et-marne" },
  { title: "Faux plafonds", text: "Plafonds techniques, décoratifs ou architecturaux adaptés aux contraintes du projet.", to: "/faux-plafonds-seine-et-marne" },
  { title: "Bandes &amp; finitions", text: "Bandes, angles, enduits et détails permettant une finition nette et durable.", to: "/plaquiste-seine-et-marne" },
  { title: "Corniches LED &amp; habillages techniques", text: "Éclairage indirect intégré et habillages soignés des éléments techniques.", to: "/faux-plafonds-seine-et-marne" },
  { title: "Aménagement intérieur", text: "Niches, habillages TV et aménagements sur mesure avec corniches LED.", to: "/amenagement-interieur-seine-et-marne" },
  { title: "Rénovation intérieure", text: "Transformation complète de vos espaces, de la préparation à la réception.", to: "/amenagement-interieur-seine-et-marne" },
];

export const Expertises = () => (
  <section id="expertises" data-testid="expertises-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading
        chapter="01 — Expertises"
        title="Nos prestations de rénovation intérieure"
        subtitle="Des ouvrages intérieurs réalisés avec précision."
        testId="expertises"
      />
      <div className="border-b border-mineral">
        {PRESTATIONS.map((p, i) => (
          <Reveal key={p.title} delay={Math.min(i * 0.05, 0.3)}>
            <Link
              to={p.to}
              data-testid={`expertise-row-${i + 1}`}
              className="group grid w-full grid-cols-12 items-center gap-4 border-t border-mineral py-6 lg:py-7 text-left transition-colors duration-300 hover:bg-white"
            >
              <span className="col-span-2 sm:col-span-1 pl-1 font-heading text-sm font-semibold tracking-[0.2em] text-sable-deep">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3
                className="col-span-9 sm:col-span-4 font-heading text-lg lg:text-xl font-semibold tracking-tight text-nuit"
                dangerouslySetInnerHTML={{ __html: p.title }}
              />
              <p className="col-span-10 col-start-3 sm:col-span-6 sm:col-start-6 text-sm leading-relaxed text-anthracite/65">
                {p.text}
              </p>
              <span className="hidden sm:flex col-span-1 justify-end pr-1 text-nuit/0 transition-[color,transform] duration-300 group-hover:text-sable-deep group-hover:translate-x-1">
                <ArrowRight size={18} strokeWidth={1.5} />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.1}>
        <p className="mt-8 text-sm text-anthracite/55" data-testid="expertises-note">
          Une prestation ne figure pas dans la liste ? Décrivez-nous votre besoin, nous l’étudierons.
        </p>
      </Reveal>
    </div>
  </section>
);
